import { render, staticRenderFns } from "./AppointmentRestrictions.vue?vue&type=template&id=94f7027c&"
import script from "./AppointmentRestrictions.vue?vue&type=script&lang=ts&setup=true&"
export * from "./AppointmentRestrictions.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94f7027c')) {
      api.createRecord('94f7027c', component.options)
    } else {
      api.reload('94f7027c', component.options)
    }
    module.hot.accept("./AppointmentRestrictions.vue?vue&type=template&id=94f7027c&", function () {
      api.rerender('94f7027c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/AppointmentRestrictions.vue"
export default component.exports